import React from 'react';
import { useStoreContext } from '../../../../contexts/stores/store.tsx';

const StoreHeader = () => {
    const { store } = useStoreContext()
    return (
        <h1>{store.name ?? "Create store"}</h1>
    );
};

export default StoreHeader;
